"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const useScrollTrigger_1 = __importDefault(require("@mui/material/useScrollTrigger"));
const Zoom_1 = __importDefault(require("@mui/material/Zoom"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const Fab_1 = __importDefault(require("@mui/material/Fab"));
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
function default_1({ altBottom }) {
    const trigger = (0, useScrollTrigger_1.default)({ disableHysteresis: true });
    const handleClick = () => {
        window.scrollTo(0, 0);
    };
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const maxWidth1024 = (0, useMediaQuery_1.default)('(max-width:1024px)');
    const maxWidth1220 = (0, useMediaQuery_1.default)('(max-width:1220px)');
    // ! 1220 = 1024px + ((60px + 30px) * 2) + 15px + 1px
    // ? 60px : FloatIcon's width
    // ? 30px : root element 기준 띄울 공간
    // ? * 2 : root element가 중앙정렬 이므로 양쪽 공간 고려
    // ? 15px : chrome browser 기준 scrollbar width
    // ? 1px : 1219가 싫어서
    const rightPosition = maxWidth768
        ? '11px'
        : maxWidth1024
            ? '30px'
            : maxWidth1220
                ? 'calc((100% - 1024px) / 2 + 30px)'
                : 'calc((100% - 1024px) / 2 - 90px)'; // ? 90px : 60px + 30px
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(Zoom_1.default, Object.assign({ in: trigger }, { children: (0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ onClick: handleClick, role: "presentation", sx: {
                position: 'fixed',
                bottom: altBottom !== null && altBottom !== void 0 ? altBottom : '74px',
                right: rightPosition,
            } }, { children: (0, jsx_runtime_1.jsxs)(Fab_1.default, Object.assign({ sx: {
                    flexDirection: 'column',
                    rowGap: '6px',
                    width: '60px',
                    height: '60px',
                    border: '1px solid white',
                    bgcolor: 'rgba(255, 255, 255, 0.7)',
                    '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.7)' },
                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
                    svg: { color: 'black' },
                }, "aria-label": "scroll back to top" }, { children: [(0, jsx_runtime_1.jsx)("span", { css: {
                            width: 0,
                            height: 0,
                            border: '8px solid transparent',
                            borderTop: 0,
                            borderBottom: '8px solid black',
                        } }), (0, jsx_runtime_1.jsx)("span", Object.assign({ css: { fontSize: '13px', lineHeight: '15px' } }, { children: t('맨위로') }))] })) })) })));
}
exports.default = default_1;
